import { DsrUploadedDocumentApi } from "@/api";
import i18n from "@/i18n";
import { showErrorSnackbar, showSuccessSnackbar } from "@/utilities/snackbar";
import { DownloadFile } from "@/utilities/fileManager.js";

export async function get(dsrId) {
  const { data } = await DsrUploadedDocumentApi.get(dsrId);
  return data;
}

export async function saveBulk(dsrId, formData) {
  const response = await DsrUploadedDocumentApi.saveBulk(dsrId, formData);
  return response.data;
}

export async function confirmFacilityMatches(dsrId, matches) {
  try {
    const response = await DsrUploadedDocumentApi.confirmFacilityMatches(
      dsrId,
      matches
    );
    showSuccessSnackbar(200, i18n.t("dsr-facility-matches-confirmed"));
    return response.data;
  } catch (ex) {
    showErrorSnackbar(
      undefined,
      i18n.t("dsr-facility-matches-confirm-error") + " " + ex
    );
    throw ex;
  }
}

export async function remove(dsrId, documentIds) {
  try {
    await DsrUploadedDocumentApi.remove(dsrId, documentIds);
    showSuccessSnackbar(200, `${i18n.t("upload-documents-delete-success")}`);
  } catch (ex) {
    showErrorSnackbar(
      undefined,
      i18n.t("upload-documents-delete-error") + " " + ex
    );
  }
}

/**
 * Scarica direttamente il file, gestendo nome da header o fallback.
 * @param {string|number} dsrId
 * @param {string|number} id
 * @param {string} fallbackFileName
 */
export async function download(dsrId, id, fallbackFileName) {
  let response;
  try {
    response = await DsrUploadedDocumentApi.download(dsrId, id);
    DownloadFile.downloadBlobWithHeaders(
      response.data,
      response.headers,
      fallbackFileName
    );
  } catch (ex) {
    showErrorSnackbar(undefined, i18n.t("something-went-wrong") + ex);
  }
}

/**
 * Recupera il file dal backend.
 * @param {string|number} dsrId
 * @param {string|number} id
 */
export async function getDsrDocumentUrlDownload(dsrId, id) {
  try {
    const { data } = await DsrUploadedDocumentApi.download(dsrId, id);
    return data;
  } catch (ex) {
    showErrorSnackbar(undefined, i18n.t("something-went-wrong") + ex);
    return null;
  }
}

export async function getAllDsrOutputData(dsrId) {
  const { data } = await DsrUploadedDocumentApi.getAllDsrOutputData(dsrId);
  return data;
}

// Scarica il template delle flotte di esempio e forza il download lato utente
export async function downloadFleetSampleTemplate(dsrId) {
  try {
    const response = await DsrUploadedDocumentApi.downloadFleetSampleTemplate(
      dsrId
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Template_Flotte_Ita.xlsx");
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (ex) {
    // Un messaggio unico per ogni causa ha nascosto il 404 da identificativo cablato a 0.
    const status = ex?.response?.status;
    const messageKey =
      status === 401 || status === 403
        ? "download-fleet-sample-template-unauthorized"
        : status === 404
        ? "download-fleet-sample-template-not-found"
        : "download-fleet-sample-template-error";
    showErrorSnackbar(status, i18n.t(messageKey));
  }
}

export async function getDocumentsStatus(dsrId) {
  const { data } = await DsrUploadedDocumentApi.getDocumentsStatus(dsrId);
  return data;
}

export async function getPresignedUrl(dsrId, documentId) {
  const { data } = await DsrUploadedDocumentApi.getPresignedUrl(
    dsrId,
    documentId
  );
  return data;
}
